//import {} from '../../node_modules/jquery/dist/jquery.js';

//import '../../node_modules/jquery/dist/jquery.js';

/* import '../../node_modules/jquery-mobile/dist/jquery.mobile.js'; */
import './vendor/jquery.mobile.js';


import {} from '../../node_modules/angular/angular.js';
import {} from '../../node_modules/angular-animate/angular-animate.min.js';
import {} from '../../node_modules/angular-sanitize/angular-sanitize.min.js';
import {} from '../../node_modules/angular-gettext/dist/angular-gettext.js';
import {} from '../../node_modules/angular-ui-notification/dist/angular-ui-notification.min.js';
import {} from '../../node_modules/angular-cookie/angular-cookie.min.js';


/* import '../../node_modules/pepjs/dist/pep.js'; */
import PointerEventsPolyfill from './vendor/pep.js';
window.PointerEventsPolyfill = PointerEventsPolyfill;


import '../../../i18n/locale/cmsserver/translations.js';
import '../../../libs/cms/ApiHandler.js';


import './app.js';

import '../../node_modules/jquery.scrollto/jquery.scrollTo.js';
import './touchPointerSwipeActions.js';
import './TimeoutRunner.js';
import './injectCurrentTimeSynchrotron.js';
import './modules/showcaseWallPreviewModule.js';

import ShowcaseEngineModifierService from './services/showcaseEngineModifierService.js';
import SettingsService               from './services/settingsService.js';

import {} from './showcase.js';

angular.module( 'showcase' )
	.service( 'showcaseEngineModifier', ShowcaseEngineModifierService )
	.service( 'settingsService',        SettingsService               );
